var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { HubSpotQuestionType } from '../enums/hubspot-question-type.enum.js';
import { HubSpotQuestionOptionFullSizeDto } from './hubspot-question-option.full-size.dto.js';
import { HubSpotQuestionAnswerFullSizeDto } from './hubspot-question.answer.full-size.dto.js';
export class HubSpotQuestionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    hubspotPropertyInternalName;
    waitDaysAfterRegistration;
    question;
    questionType;
    options;
    answers;
    visibleForRoles;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], HubSpotQuestionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], HubSpotQuestionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionFullSizeDto.prototype, "hubspotPropertyInternalName", void 0);
__decorate([
    IsNumber(),
    Exclude(),
    __metadata("design:type", Number)
], HubSpotQuestionFullSizeDto.prototype, "waitDaysAfterRegistration", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionFullSizeDto.prototype, "question", void 0);
__decorate([
    IsEnum(HubSpotQuestionType),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionFullSizeDto.prototype, "questionType", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => HubSpotQuestionOptionFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], HubSpotQuestionFullSizeDto.prototype, "options", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => HubSpotQuestionAnswerFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], HubSpotQuestionFullSizeDto.prototype, "answers", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], HubSpotQuestionFullSizeDto.prototype, "visibleForRoles", void 0);
//# sourceMappingURL=hubspot-question.full-size.dto.js.map